// hrExpensesReducer.js
import {
  EXPENSES_DOC_CATEGORIES,
  EXPENSES_ID_DOC,
  GET_ALL_HR_EXPENSES,
  HANDLE_APPROVED_EXPENSES,
  HANDLE_EXPENSE_CATAGORIES,
  HANDLE_EXPENSES_PAGINATION,
  HANDLE_EXPENSES_TOTALPRICE,
} from './action'

const initialState = {
  hrExpenses: [],
}

const hrExpensesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_HR_EXPENSES:
      return {
        ...state,
        hrExpenses: action.payload.hrExpenses,
      }
    case HANDLE_EXPENSES_PAGINATION:
      return {
        ...state,
        hrExpensesPagination: action.payload,
      }
    case HANDLE_APPROVED_EXPENSES:
      return {
        ...state,
        approvedExpenses: action.payload,
      }
    case HANDLE_EXPENSE_CATAGORIES:
      return {
        ...state,
        expenseCategories: action.payload,
      }
    case HANDLE_EXPENSES_TOTALPRICE:
      return {
        ...state,
        expenseTotalPrice: action.payload,
      }
    case EXPENSES_DOC_CATEGORIES:
      return {
        ...state,
        expenseDocCategories: action.payload,
      }
    case EXPENSES_ID_DOC:
      return {
        ...state,
        expenseIdDoc: action.payload,
      }
    default:
      return state
  }
}

export default hrExpensesReducer
